export default "__VITE_ASSET__R7L4_QlQ__"